import SidebarLayout from "@/components/feature/SidebarLayout";
import { useScrollReveal, getRevealClass } from "@/hooks/useScrollReveal";

export default function Talent() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <SidebarLayout breadcrumbs={[{ label: '所属タレント' }]}>

      {/* Hero */}
      <section className="px-4 md:px-6 lg:px-10 mb-10">
        <div className="relative w-full aspect-square md:aspect-auto md:h-[84vh] md:min-h-[532px] md:max-h-[952px] overflow-hidden rounded-2xl">
          <img
            src="https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/27d5857c9b787d33693395dfe697ebf8.webp"
            alt="所属タレント"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-black/25" />
          <div ref={ref} className={`absolute inset-0 flex flex-col items-center justify-center z-10 ${getRevealClass(isVisible)}`}>
            <h1
              className="text-3xl sm:text-4xl md:text-5xl font-bold text-white tracking-wide"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              所属タレント
            </h1>
            <p
              className="text-xs sm:text-sm text-white/80 mt-2 tracking-wider"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              talent
            </p>
          </div>
        </div>
      </section>

      {/* Profile Content */}
      <div className="px-4 md:px-6 lg:px-10 pb-16 md:pb-24">
        <div className="bg-white rounded-2xl p-8 md:p-12 lg:p-16">
          <div className="flex flex-col gap-10 lg:gap-14">
            {/* Profile Image */}
            <div className="w-full flex justify-center">
              <div className="w-full max-w-md aspect-[3/4] overflow-hidden rounded-xl">
                <img
                  src="https://storage.helloreaddy.io/project_files/3947077b-25d2-4d94-b656-7a710d99b9c9/02398040-a1d8-453b-8ef7-9b70ddbc1965_compressed_IMG_0940.webp"
                  alt="森 祐作 宣材写真"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Profile Text */}
            <div className="space-y-10 max-w-3xl mx-auto">
              {/* Name */}
              <div>
                <h2
                  className="text-3xl md:text-4xl font-bold text-black tracking-wide"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  森 祐作
                </h2>
                <p className="text-sm text-gray-400 mt-2" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>Yusaku Mori</p>
              </div>

              {/* Basic Info */}
              <div className="space-y-2 text-base md:text-lg text-gray-700 leading-relaxed" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                <p><strong className="text-black">生年月日</strong> / 1984年11月28日</p>
                <p><strong className="text-black">出身地</strong> / 大分県豊後大野市</p>
                <p><strong className="text-black">学歴</strong> / 大分県立三重高等学校卒業</p>
                <p><strong className="text-black">資格・特技</strong> / 普通自動車運転免許、普通自動二輪免許、大分県剣道連盟認定剣道４段</p>
                <p><strong className="text-black">大使</strong> / 豊後大野市ふるさと大使、臼杵カボス応援大使、味チョクご当地グルメ応援大使</p>
              </div>

              {/* Biography */}
              <div className="pt-6 border-t border-gray-100">
                <h3
                  className="text-xl md:text-2xl font-bold text-black tracking-wide mb-6"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  経歴
                </h3>
                <div className="space-y-5 text-base md:text-lg text-gray-700 leading-[1.9]" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                  <p>
                    大分県豊後大野市出身。
                    <br />
                    21歳の時に俳優を目指し福岡へ。プロダクションに所属し役者として舞台・CM・雑誌モデル・ドラマなどの表現活動をスタート。
                    <br />
                    演者だけではなくドラマ撮影現場の助監督として演出部の仕事も経験。
                  </p>
                  <p>
                    25歳で福岡から上京。
                    <br />
                    東京の俳優養成学校「映画24区」のスクール1期生として表現を学ぶ。またドラマ・映画の撮影現場で役者として活動する一方、制作部としての仕事も経験。
                  </p>
                  <p>
                    2014年、大分県のTV番組にレギュラー出演が決まったことがきっかけで県内でのタレント活動をスタートする為帰郷。
                    <br />
                    大分県のローカルタレントとして民放テレビ、ケーブルテレビ、県内各地のイベント出演、また近年は講演依頼も多く学校講演にも多数登壇。
                  </p>
                  <p>
                    2020年には故郷豊後大野市の「ふるさと大使」にも就任。
                  </p>
                  <p>
                    2021年、自身のマネジメントを目的とした個人事務所「マイベース大分株式会社」（現・株式会社OLカンパニー）を設立し代表取締役に就任。
                  </p>
                  <p>
                    近年はタレントとしても活動しながら、テレビ番組の企画・構成・プロデュースなど自社制作番組等も手掛けるようになる。
                  </p>
                  <p>
                    2026年、臼杵市から「うすきカボス応援大使」を任命いただき就任。
                  </p>
                </div>
              </div>

              {/* Achievements */}
              <div className="pt-6 border-t border-gray-100">
                <h3
                  className="text-xl md:text-2xl font-bold text-black tracking-wide mb-6"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  森祐作実績一覧
                </h3>

                <div className="space-y-8 text-base text-gray-700 leading-[1.9]" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>

                  {/* CM出演 */}
                  <div>
                    <p className="font-bold text-black mb-2">【CM出演】</p>
                    <p className="text-gray-600">
                      HottMotto / 吉備国際大学 / 西鉄バス / うまかっちゃん / 髙山質店 / やよい軒 / 霧島酒造 / 九州電力キューデンヴォルデクス / 株式会社新長崎商事 / 塗装工房ナカムラ / 三信産業株式会社 / 新電力おおいた株式会社 / 他
                    </p>
                  </div>

                  {/* TV ドラマ出演 */}
                  <div>
                    <p className="font-bold text-black mb-2">【TV ドラマ出演】</p>
                    <p className="text-gray-600">
                      KBC九州朝日放送「ゆりかご」/ テレビ朝日 土曜ワイド劇場「司法教官 穂高美子」/ フジテレビ 金曜プレステージ「外科医 鳩村周五郎」/ TBS「ドラゴン青年団」
                    </p>
                  </div>

                  {/* スチール・雑誌コラム */}
                  <div>
                    <p className="font-bold text-black mb-2">【スチール・雑誌コラム】</p>
                    <p className="text-gray-600">
                      坊ちゃん文学賞メインポスター / じゃらん / シティ情報おおいた / オオイタドリップ / 帝国書院 祭りの地図
                    </p>
                  </div>

                  {/* 映画出演 */}
                  <div>
                    <p className="font-bold text-black mb-2">【映画出演】</p>
                    <p className="text-gray-600">
                      「傷跡」/「砂をつかんで立ち上がれ」/「女たちの都」/「ナンバのハンパな借金取り〜陽気なカッパと珍道中〜」
                    </p>
                  </div>

                  {/* TVレギュラー出演 */}
                  <div>
                    <p className="font-bold text-black mb-2">【TVレギュラー出演】</p>
                    <div className="text-gray-600 space-y-1">
                      <p>◯ TOSテレビ大分<br />「スパーク魂」「ゆ〜わくワイド」「大分発アウトドアch.ソトアソ！」</p>
                      <p>◯ ぶんごおおのケーブルテレビ<br />「週間！情報トレイン」「森祐作の地域を知る」</p>
                      <p>◯ 臼杵ケーブルネット<br />「うすき大好き」「森旅」</p>
                    </div>
                  </div>

                  {/* 特別番組出演 */}
                  <div>
                    <p className="font-bold text-black mb-2">【特別番組出演】</p>
                    <div className="text-gray-600 space-y-1">
                      <p>◯ BSフジ<br />「わがまま！気まま！旅気分！」</p>
                      <p>◯ TOSテレビ大分<br />「正月特番 アタック大分」</p>
                      <p>◯ 臼杵ケーブルネット<br />「特別番組臼杵祇園まつり」</p>
                      <p>他</p>
                    </div>
                  </div>

                  {/* インタビュー実績一覧 */}
                  <div>
                    <p className="font-bold text-black mb-3">【インタビュー実績一覧】</p>

                    <div className="mb-3">
                      <p className="font-bold text-black text-sm mb-1">映画監督（五十音順）</p>
                      <ul className="text-gray-600 space-y-0.5 list-none pl-0">
                        <li>是枝裕和監督</li>
                        <li>神山健治監督</li>
                        <li>木村大作監督</li>
                        <li>小林聖太郎監督</li>
                        <li>瀬々敬久監督</li>
                        <li>成島出監督</li>
                        <li>中村義洋監督</li>
                        <li>西谷弘監督</li>
                        <li>廣木隆一監督</li>
                        <li>矢口史靖監督</li>
                        <li>山崎貴監督</li>
                        <li>吉田康弘監督</li>
                        <li>若松節朗監督</li>
                      </ul>
                    </div>

                    <div>
                      <p className="font-bold text-black text-sm mb-1">俳優（五十音順）</p>
                      <ul className="text-gray-600 space-y-0.5 list-none pl-0">
                        <li>秋元才加さん(元AKB48)</li>
                        <li>阿部寛さん</li>
                        <li>有村架純さん</li>
                        <li>伊勢谷友介さん</li>
                        <li>上戸彩さん</li>
                        <li>川口春奈さん</li>
                        <li>栗山千明さん</li>
                        <li>堺雅人さん</li>
                        <li>坂口健太郎さん</li>
                        <li>佐々木蔵之介さん</li>
                        <li>佐藤浩一さん</li>
                        <li>佐野玲於さん(GENERATIONS)</li>
                        <li>櫻井翔さん(元嵐)</li>
                        <li>志尊淳さん</li>
                        <li>小杉竜一さん(ブラックマヨネーズ)</li>
                        <li>小手伸也さん</li>
                        <li>高畑充希さん</li>
                        <li>竹内結子さん</li>
                        <li>竹中直人さん</li>
                        <li>土屋太鳳さん</li>
                        <li>中川大志さん</li>
                        <li>中条あやみさん</li>
                        <li>長澤まさみさん</li>
                        <li>東出昌大さん</li>
                        <li>ファンキー加藤さん(FUNKY MONKEY BΛBY'S)</li>
                        <li>福士蒼汰さん</li>
                        <li>本田望結さん</li>
                        <li>松重豊さん</li>
                        <li>松下奈緒さん</li>
                        <li>町田啓太さん</li>
                        <li>満島真之介さん</li>
                        <li>宮迫博之さん(元雨上がり決死隊)</li>
                        <li>山崎賢人さん</li>
                        <li>横浜流星さん</li>
                        <li>横山裕さん(SUPER EIGHT)</li>
                        <li>米倉涼子さん</li>
                        <li>リリー・フランキーさん</li>
                      </ul>
                    </div>
                  </div>

                  {/* その他動画出演 */}
                  <div>
                    <p className="font-bold text-black mb-2">【その他動画出演】</p>
                    <p className="text-gray-600">
                      カラオケDAM PV / 大分県作業療法協会 YouTube / 他
                    </p>
                  </div>

                  {/* ナレーション */}
                  <div>
                    <p className="font-bold text-black mb-2">【ナレーション】</p>
                    <p className="text-gray-600">
                      ドキュメンタリー番組「シネマバード〜お寺が映画館になった日」/ 豊後大野市居住支援協議会CM / 海と日本プロジェクト / 他
                    </p>
                  </div>

                  {/* ラジオ */}
                  <div>
                    <p className="font-bold text-black mb-2">【ラジオ】</p>
                    <p className="text-gray-600">
                      OBSラジオ 敬老の日特番「ありがとうを伝えるラジオ」他
                    </p>
                  </div>

                  {/* スタッフ */}
                  <div>
                    <p className="font-bold text-black mb-2">【スタッフ】</p>
                    <p className="text-gray-600">
                      演出部 助監督：KBC九州朝日放送「ゆりかご」/ 制作部：劇場版「ミューズの鏡」/ テレビ朝日「司法教官 穂高美子」/ フジテレビ「外科医 鳩村周五郎」/ TBS「ドラゴン青年団」
                    </p>
                  </div>

                  {/* 企画・プロデュース */}
                  <div>
                    <p className="font-bold text-black mb-2">【企画・プロデュース】</p>
                    <p className="text-gray-600">
                      臼杵ケーブルネット「森旅」/ TOSテレビ大分「大分発アウトドアch.ソトアソ！」他
                    </p>
                  </div>

                  {/* 講演 */}
                  <div>
                    <p className="font-bold text-black mb-2">【講演】</p>
                    <p className="text-gray-600">
                      大分県立三重総合高等学校 / 大分県立臼杵高等学校 / 豊後大野市立三重中学校 / 豊後大野市立朝地中学校 / 豊後大野市立犬飼中学校 / 由布市立湯布院中学校 / 豊後大野市立菅尾小学校 / 国立高等専門学校機構大分工業高等専門学校 / 大分県企業農業参入セミナー / 豊後大野市民講座 / 全果連柑橘部会担い手交流会大分県大会 / 大分県立三重総合高等学校20周年記念式典講演 / 他
                    </p>
                  </div>

                  {/* 司会・MC */}
                  <div>
                    <p className="font-bold text-black mb-2">【司会・MC】</p>
                    <p className="text-gray-600">
                      豊後大野市ふるさと祭り / 朝地神楽祭り / ぶんごおおのミュージックフェスタ / チューリップフェスタ / あさじ夏祭まつり / ユネスコエコパークPRイベント / 平和市民公園能楽堂今昔響舞 / みえまちホコ天 / 市場通りものがたりプロジェクト / ぶんごおおのフェスタ / 大分県市長会 秋季定例会 懇親会 / 道の駅みえ秋まつり / 深山流岩戸神楽交流大会 / 朝地駅開業100周年記念式典 / 菅尾ふれあい文化祭 / 三重町わくわく文化祭 / みえまちホコマル / bungobuono駅前マルシェ / 臼杵市八町大路福幸音楽祭 / みずほ厚生センタードリームフェスタ / 大分県かぼす振興協議会かぼすジャック / うすき食文化祭 / ダンスイベントoita street core / 豊後大野ジオパーク防災シンポジウム / うすき復興バザール / ちとせ夏祭り / にじが丘夏まつり / さいきアジングカップ / うすき竹宵 / パーマフェスうすき / 臼杵商工会議所青年部会創立50周年記念式典 / 他
                    </p>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SidebarLayout>
  );
}